/* import __COLOCATED_TEMPLATE__ from './rename-group-modal.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type PlaygroundApiService from 'embercom/services/playground-api';
import type { Playground } from 'embercom/lib/fin-playground/playground';
import { localCopy } from 'tracked-toolbox';

interface RenameGroupModalArgs {
  onClose: () => void;
  playground: Playground;
}

export default class RenameGroupModal extends Component<RenameGroupModalArgs> {
  @service declare playgroundApi: PlaygroundApiService;

  @localCopy('args.playground.groupName') declare groupName: string;

  get disableSaveButton() {
    return this.groupName.trim() === '' || this.groupName === this.args.playground.groupName;
  }

  @action renameGroup() {
    if (!this.args.playground.id) {
      return;
    }
    this.args.playground.updateGroupName(this.groupName);
    this.playgroundApi.updatePlaygroundGroup(this.args.playground.id, this.groupName);
    this.args.onClose();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::Modals::RenameGroupModal': typeof RenameGroupModal;
  }
}
